/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Outstanding_SubInputs */



/**
* | output |
* | --- |
* | "No invoice created yet · {count} partners" |
*
* @param {Partner_Billing_Board_Outstanding_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_outstanding_sub = /** @type {((inputs: Partner_Billing_Board_Outstanding_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Outstanding_SubInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Noch keine Rechnung erstellt · ${i?.count} Partner`)
	return /** @type {LocalizedString} */ (`No invoice created yet · ${i?.count} partners`)
});